import { render, staticRenderFns } from "./Tijiao.vue?vue&type=template&id=7383b38a&"
import script from "./Tijiao.vue?vue&type=script&lang=js&"
export * from "./Tijiao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports